module.exports = __webpack_public_path__ + "img/ic_park@2x.ceeb5d9e.png";